//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';

export default {
    name: "AppPagination",
	computed: {
        ...mapGetters(['getPages', 'getTotalPages', 'getCurrentPage'])
    },
    methods: {
        ...mapActions(['changePage'])
    }
};
